function enableMenuFocusWrap($trigger, $menu) {
	var $focusable = $menu.find('a, button, [tabindex="0"]');
	var $last = $focusable.last();

	// When Tab on last item → return focus to trigger
	$last.on("keydown.menuWrap", function (e) {
		if (e.key === "Tab" && !e.shiftKey) {
			e.preventDefault();
			$trigger.trigger("focus");
		}
	});
}
(function ($) {
	$(".rl-2024-main-navigation__toggle-menu").on("click", function () {
		// $(".rl-2024-main-navigation__menu").toggleClass("active");
		$(this).toggleClass("active");
		if ($(this).hasClass("active")) {
			$(this).attr("aria-expanded", "true");
			$(".rl-2024-main-navigation__menu").removeAttr("hidden");
			$(".rl-2024-main-navigation__menu").addClass("active");
		} else {
			$(this).attr("aria-expanded", "false");
			$(".rl-2024-main-navigation__menu").attr("hidden", true);
			$(".rl-2024-main-navigation__menu").removeClass("active");
		}
		enableMenuFocusWrap($(this), $(".rl-2024-main-navigation__menu"));
	});
	$("#model-availability-btn").click(function () {
		console.log("model-availability-btn");

		$("html, body").animate(
			{
				scrollTop: $("#model-availability").offset().top,
			},
			1000,
		); // Adjust the speed as needed (1000 milliseconds = 1 second)
	});
	$(".rl-2024-keep-exploring__slider").slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		infinite: false,
		dots: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	});
	$(".rl-2024-watch-cover__price  .rl-2024-watch-cover__note__icon").on(
		"click",
		function (e) {
			e.stopPropagation();
			// $(this)
			// 	.next(".rl-2024-watch-cover__note__content")
			// 	.toggleClass("active");
		},
	);

	$(".open-hours").each(function () {
		// var openHours = [
		// 	{
		// 		day: "Sunday",
		// 		time: "CLOSED",
		// 	},
		// 	{
		// 		day: "Monday",
		// 		time: "CLOSED",
		// 	},
		// 	{
		// 		day: "Tuesday",
		// 		time: "10:00am - 5:00pm",
		// 	},
		// 	{
		// 		day: "Wednesday",
		// 		time: "10:00am - 7:00pm",
		// 	},
		// 	{
		// 		day: "Thursday",
		// 		time: "10:00am - 5:00pm",
		// 	},
		// 	{
		// 		day: "Friday",
		// 		time: "10:00am - 5:00pm",
		// 	},
		// 	{
		// 		day: "Saturday",
		// 		time: "10:00am - 5:00pm",
		// 	},
		// ];
		if ($(this).hasClass("ponte-vedra-beach")) {
			var openHours = [
				{
					day: "Monday",
					time: "10:00am - 6:00pm",
					index: 1,
				},
				{
					day: "Tuesday",
					time: "10:00am - 6:00pm",
					index: 2,
				},
				{
					day: "Wednesday",
					time: "Closed",
					index: 3,
				},
				{
					day: "Thursday",
					time: "Closed",
					index: 4,
				},
				{
					day: "Friday",
					time: "10:00am - 6:00pm",
					index: 5,
				},
				{
					day: "Saturday",
					time: "10:00am - 5:00pm",
					index: 6,
				},
				{
					day: "Sunday",
					time: "Closed",
					index: 0,
				},
			];
		} else {
			var openHours = [
				{
					day: "Monday",
					time: "10:00am - 5:30pm",
					index: 1,
				},
				{
					day: "Tuesday",
					time: "10:00am - 5:30pm",
					index: 2,
				},
				{
					day: "Wednesday",
					time: "10:00am - 5:30pm",
					index: 3,
				},
				{
					day: "Thursday",
					time: "10:00am - 5:30pm",
					index: 4,
				},
				{
					day: "Friday",
					time: "10:00am - 5:30pm",
					index: 5,
				},
				{
					day: "Saturday",
					time: "10:00am - 5:00pm",
					index: 6,
				},
				{
					day: "Sunday",
					time: "Closed",
					index: 0,
				},
			];
		}

		var date = new Date();
		var dateOfWeek = date.getDay();
		var optionHTML =
			'<option disabled value="#value#">#day#: #time#</option>';
		var liHTML = '<li value="#value#"><span>#day#</span> #time#</li>';
		var items = openHours.map(function (item, index) {
			return optionHTML
				.replace("#value#", index)
				.replace("#day#", item.day)
				.replace("#time#", item.time);
		});
		var li = openHours.map(function (item, index) {
			return liHTML
				.replace("#value#", index)
				.replace("#day#", item.day)
				.replace("#time#", item.time);
		});
		var $selected = $(
			'<div class="open-hours__selected-time outline-light" tabindex="0"></div>',
		);
		var $select = $("<select>" + items.join("") + "</select>");
		var $ul = $("<ul>" + li.join("") + "</ul>");
		var toDay = openHours.find((item) => item.index == dateOfWeek);
		if (toDay.time !== "Closed") {
			$selected.append(
				`<div><strong>#day#:</strong> #time# <span class='arrow'>
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">
<path fill="currentColor" d="M7.5,11.6L0,3.4h15L7.5,11.6z"/>
</svg></span></div>`
					.replace("#day#", "Open Today")
					.replace("#time#", toDay.time),
			);
		} else {
			$selected.append(
				"<div><strong>#day#</strong></div>".replace(
					"#day#",
					"Closed Today",
				),
			);
		}
		$select.on("change", function () {
			var val = Number($(this).val());
			var selectedDay = openHours.find((item) => item.index == val);
			$selected.html(
				"<div><strong>#day#</strong>: #time#</div>"
					.replace("#day#", selectedDay.day)
					.replace("#time#", selectedDay.time),
			);
		});
		$(this).append($selected);
		//$(this).append($select);
		$(this).append($ul);
		$selected
			.on("click", function () {
				$(".open-hours").toggleClass("active");
			})
			.on("keydown", function (e) {
				if (e.key === "Enter") {
					$selected.trigger("click");
				}
			});
		$(document).on("click", function (e) {
			const target = e.target;
			console.log("target", target);
			const isOpenHours =
				$(target).hasClass("open-hours") ||
				$(target).parents(".open-hours").length > 0;
			console.log(
				"isOpenHours",
				isOpenHours,
				$(target).hasClass("open-hours"),
				$(target).parents(".open-hours").length,
			);
			if (!isOpenHours) {
				$(".open-hours").removeClass("active");
			}
		});
	});
	function initMap() {
		$(".rolex-map").each(function () {
			var lat = $(this).data("lat");
			var lng = $(this).data("lng");
			var pin =
				$(this).data("pin") ||
				"https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png";
			var mapOptions = {
				// How zoomed in you want the map to start at (always required)
				zoom: 17,
				streetViewControl: false,
				// The latitude and longitude to center the map (always required)
				center: new google.maps.LatLng(lat, lng),
				// New York
				// How you would like to style the map.
				// This is where you would paste any style found on Snazzy Maps.
				styles: [
					{
						featureType: "administrative",
						elementType: "all",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "administrative",
						elementType: "labels",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "administrative",
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#6e6c6c",
							},
						],
					},
					{
						featureType: "administrative.country",
						elementType: "geometry",
						stylers: [
							{
								weight: "0.85",
							},
							{
								lightness: "45",
							},
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "landscape",
						elementType: "all",
						stylers: [
							{
								color: "#f2f2f2",
							},
						],
					},
					{
						featureType: "landscape",
						elementType: "geometry",
						stylers: [
							{
								gamma: "1.09",
							},
							{
								lightness: "19",
							},
						],
					},
					{
						featureType: "landscape",
						elementType: "labels",
						stylers: [
							{
								visibility: "on",
							},
							{
								lightness: "-21",
							},
							{
								weight: "0.01",
							},
						],
					},
					{
						featureType: "landscape.natural.landcover",
						elementType: "geometry",
						stylers: [
							{
								saturation: "8",
							},
							{
								lightness: "8",
							},
						],
					},
					{
						featureType: "landscape.natural.landcover",
						elementType: "geometry.fill",
						stylers: [
							{
								lightness: "6",
							},
						],
					},
					{
						featureType: "poi",
						elementType: "all",
						stylers: [
							{
								visibility: "off",
							},
							{
								saturation: "1",
							},
							{
								color: "#cfe1d3",
							},
						],
					},
					{
						featureType: "poi",
						elementType: "geometry",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "poi.attraction",
						elementType: "labels",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "poi.medical",
						elementType: "geometry.fill",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "poi.medical",
						elementType: "geometry.stroke",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "poi.park",
						elementType: "geometry",
						stylers: [
							{
								visibility: "on",
							},
							{
								color: "#cfe1d3",
							},
						],
					},
					{
						featureType: "road",
						elementType: "all",
						stylers: [
							{
								saturation: -100,
							},
							{
								lightness: 45,
							},
						],
					},
					{
						featureType: "road",
						elementType: "geometry.fill",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "all",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry",
						stylers: [
							{
								visibility: "on",
							},
							{
								color: "#dcdfe2",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry.fill",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry.stroke",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "labels.icon",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "road.highway.controlled_access",
						elementType: "geometry",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "road.highway.controlled_access",
						elementType: "geometry.stroke",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.highway.controlled_access",
						elementType: "labels",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "road.arterial",
						elementType: "geometry",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.arterial",
						elementType: "labels.icon",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "road.local",
						elementType: "all",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.local",
						elementType: "geometry",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.local",
						elementType: "geometry.fill",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "road.local",
						elementType: "labels",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "transit",
						elementType: "all",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "transit",
						elementType: "geometry.fill",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "transit.line",
						elementType: "geometry",
						stylers: [
							{
								visibility: "off",
							},
						],
					},
					{
						featureType: "transit.station",
						elementType: "all",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "transit.station",
						elementType: "geometry",
						stylers: [
							{
								gamma: "1.57",
							},
							{
								lightness: "-10",
							},
						],
					},
					{
						featureType: "transit.station",
						elementType: "labels",
						stylers: [
							{
								weight: "0.01",
							},
							{
								visibility: "on",
							},
							{
								saturation: "-100",
							},
							{
								lightness: "-3",
							},
						],
					},
					{
						featureType: "transit.station",
						elementType: "labels.icon",
						stylers: [
							{
								weight: "0.01",
							},
						],
					},
					{
						featureType: "water",
						elementType: "geometry",
						stylers: [
							{
								color: "#c2d8e1",
							},
						],
					},
					{
						featureType: "water",
						elementType: "labels.text",
						stylers: [
							{
								visibility: "on",
							},
							{
								color: "#b0bdc7",
							},
						],
					},
				],
			}; // Basic options for a simple Google Map
			// For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
			// Get the HTML DOM element that will contain your map
			// We are using a div with id="map" seen below in the <body>

			var mapElement = $(this)[0]; // Create the Google Map using our element and options defined above

			var map = new google.maps.Map(mapElement, mapOptions); // Let's also add a marker while we're at it

			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(lat, lng),
				map: map,
				icon: pin,
			});
		});
	}
	google.maps.event.addDomListener(window, "load", initMap);

	$("a[href='#rl-2024-contact-form']").on("click", function () {
		$("#rl-2024-contact-form").modal("show");
	});

	$(document).on("focus", ".rolex-contact-form .gfield input", function () {
		const parent = $(this).parents(".gfield");

		$(parent).addClass("focus");
	});

	$(document).on(
		"focusout",
		".rolex-contact-form .gfield input",
		function () {
			const parent = $(this).parents(".gfield");
			const value = $(this).val();

			if (!value) {
				$(parent).removeClass("focus");
			}
		},
	);

	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		if (form_id == 11) {
			console.log("track contactForm");
			_satellite.track("contactForm");
			setTimeout(() => {
				window.location.href = "/rolex/thank-you/";
			}, 500);
		}
	});

	//// Rolex 2024 tracking button contact page

	// Track click on specific "getDirections" links
	$("a").on("click", function (event) {
		const href = $(this).attr("href");
		if (
			href === "https://maps.app.goo.gl/CiBRwNW2NVcrHgm48" ||
			href === "https://maps.app.goo.gl/7c7j5CLafnREUruy8"
		) {
			console.log("track getDirections");
			_satellite.track("getDirections");
		}
	});

	// Track click on specific "Call" links
	$("a").on("click", function (event) {
		const href = $(this).attr("href");
		if (href === "tel:9043989741" || href === "tel:9042801202") {
			console.log("track contactCall");
			_satellite.track("contactCall");
		}
	});

	$(document).on("click", ".rl-2024-products-grid__more", function (e) {
		e.preventDefault();

		const that = $(this);
		const parent = $(this).parents(".rl-2024-products-grid");
		const productsContainer = $(parent).find(
			".rl-2024-products-grid__inner",
		);
		const config = JSON.parse($(parent).attr("data-config"));
		const page = config?.page || 1;

		if (!$(parent).hasClass("loading")) {
			$(parent).addClass("loading");
			$.ajax({
				url: rolexJSData.ajaxUrl,
				data: {
					action: "get_rolex_products",
					collections: config?.terms || [],
					page,
				},
				dataType: "json",
				success: function (res) {
					const { products, next_page, total_pages } = res;

					$(parent).attr(
						"data-config",
						JSON.stringify({
							...config,
							page: next_page,
						}),
					);

					$(".rl-2024-products-grid__item").last().trigger("focus");

					$(productsContainer).append(products);

					if (page >= total_pages) {
						$(that).hide();
					}
				},
				complete: function () {
					$(parent).removeClass("loading");
				},
			});
		}
	});

	$(document).ready(function () {
		// When the banner phone list is clicked
		$(".banner-phone-list").on("click", function (e) {
			e.stopPropagation(); // Stop event from bubbling up to the document
			$(this).toggleClass("active"); // Toggle the active class on click
		});

		// When clicking outside of the banner phone list or modal contents
		$(document).on("click", function () {
			$(".banner-phone-list").removeClass("active"); // Remove active class
		});

		// Prevent clicking inside modal content from removing the active class
		$(".banner-phone-list, .contact-modal-product").on(
			"click",
			function (e) {
				e.stopPropagation(); // Prevent the event from reaching the document
			},
		);

		$(document).on("keydown", function (e) {
			if (e.key === "Escape") {
				$(".banner-phone-list").removeClass("active"); // Remove active class on Escape key press
			}
		});
	});

	$(".rl-2024-watch-gallery").each(function (index, el) {
		const mainImage = $(".rl-2024-watch-cover .rl-2024-watch-cover__img");
		const inner = $(el).find(".rl-2024-watch-gallery__inner");

		$(inner).slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: false,
			dots: false,
			adaptiveHeight: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
					},
				},
			],
		});

		// $(el)
		// 	.find(".rl-2024-watch-gallery__item")
		// 	.on("click", function () {
		// 		const image = $(this).html();
		// 		mainImage.html(image);
		// 	});

		$(el)
			.find(".rl-2024-watch-gallery__item")
			.each(function () {
				$img = $(this).find("img");

				$(this).attr("tabindex", "-1");
				$img.attr("tabindex", "0");

				$img.on("keydown", function (event) {
					console.log("keydown", event.key);
					if (event.key === "Enter") {
						console.log("trigger click");
						$img.trigger("click");
					}
				});
			});
	});

	$(".selling-points__list__item").each(function (index, el) {
		const title = $(el).find(".selling-points__list__item__title");

		$(title)
			.on("click", function () {
				$(".selling-points__list__item")
					.not($(el))
					.removeClass("active");
				$(el).toggleClass("active");
			})
			.on("keydown", function (event) {
				if (event.key === "Enter") {
					$(title).trigger("click");
				}
			});
	});
	document.addEventListener("click", function (e) {
		const thumbnail = e.target.closest(".video-thumbnail");
		if (!thumbnail) return;

		const wrapper = thumbnail.closest(".rl-2024-video__inner");
		if (!wrapper) return;

		const overlay = wrapper.querySelector(".video-thumbnail-overlay");
		if (overlay) {
			thumbnail.style.opacity = "0";
			overlay.style.opacity = "0";
			setTimeout(() => {
				thumbnail.style.display = "none";
				overlay.style.display = "none";
			}, 300);
		}

		const iframe = wrapper.querySelector(".youtube-player");
		if (iframe) {
			let src = iframe.getAttribute("src");

			if (!src.includes("autoplay=1")) {
				const separator = src.includes("?") ? "&" : "?";
				iframe.src = src + separator + "autoplay=1";
			}
		}
	});
	$(".video-thumbnail-overlay").on("keydown", function (e) {
		if (e.key === "Enter") {
			e.preventDefault();
			$parent = $(this).parents(".rl-2024-video__inner");
			$thumbnail = $parent.find(".video-thumbnail");
			$thumbnail.trigger("click");
		}
	});

	//Fancybox
	Fancybox.bind('[data-fancybox="rolex-gallery-pc"]', {
		hideScrollbar: true,
	});

	$(".toggle-button").on("click", function () {
		const target = $(this).attr("target");
		$(target).toggleClass("active");
		$(this).toggleClass("active");
	});

	$(".rolex-download").on("click", function (e) {
		const href = $(this).attr("href");
		if (href) {
			_satellite.track("download");
		}
	});

	$(".rl-2024-rolex-selection__inner").slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		infinite: false,
		dots: true,
		arrows: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	});

	$(".toggle-button").on("click", function () {
		const target = $(this).attr("target");
		$(target).toggleClass("active");
		$(this).toggleClass("active");
	});

	$(".rolex-filter__item__label").on("click", function () {
		$(this).toggleClass("active");
	});

	$(".rolex-toggle-filter").on("click", function () {
		var target = $(this).data("target");

		$(target).toggleClass("active");
		$("body").toggleClass("rolex-filter-open");
	});

	$(document).on("click", ".rolex-filter__reset", function () {
		FWP._mobileConfirm = true;
		FWP.reset();
	});

	$(document).on("click", ".rolex-filter__confirm", function () {
		FWP._mobileConfirm = true;
		FWP.refresh();
		$("#rolex-filter").removeClass("active");
		$("body").removeClass("rolex-filter-open");
	});

	document.addEventListener("facetwp-ready", function () {
		FWP.auto_refresh = false;
	});

	$(document).on("facetwp-loaded", function () {
		$(".facetwp-load-more").each(function () {
			$(this).addClass("rl-btn rl-btn--primary rl-btn--icon-left");
			if (!$(this).find(".icon").length) {
				$(this).prepend(
					'<span class="icon"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><polygon points="14,7 9,7 9,2 7,2 7,7 2,7 2,9 7,9 7,14 9,14 9,9 14,9" fill="currentColor"/></svg></span>',
				);
			}
		});
	});
	$(document).on("facetwp-refresh", function () {
		if (typeof FWP !== "undefined") {
			FWP.enable_scroll = false;
		}
	});
})(jQuery);
